<template>
	<div class="yes-no-view">
		<div :class="{ yes: true, active: value }" @click="$emit('input', true)">Ja</div>
		<div :class="{ no: true, active: !value }" @click="$emit('input', false)">Nej</div>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: Boolean
			}
		}
	}
</script>

<style lang="scss" scoped>
	.yes-no-view {
		width: 100%;
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 1px;
		border: 1px solid #d1d1d1;
		border-radius: 3px;
		background-color: #d1d1d1;

		& > div {
			text-align: center;
			line-height: 40px;
			background-color: rgb(241, 241, 241);
			color: rgb(170, 170, 170);
			cursor: pointer;

			&.active {
				background-color: white;
				color: black;
			}
		}
	}
</style>